import { INearbyResort } from 'api/region/types';
import classNames from 'classnames';
import Link from 'next/link';
import { Routes } from 'routes';
import { ImageComponent } from 'components/common/ImageComponent';
import { useMemo } from 'react';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { SwiperComponent, SwiperSlideItem } from 'components/blocks/SwiperComponent';
import styles from './styles.module.scss';
import { SectionHeader } from '../SectionHeader';

const swiperBreakpoints = {
  320: {
    slidesPerView: 1,
  },
  576: {
    slidesPerView: 1.925,
  },
  762: {
    slidesPerView: 2,
  },
  1200: {
    slidesPerView: 3,
  },
};

interface Props {
  nearbyResorts: INearbyResort[];
  isSummerMode?: boolean;
}

export const NearbyResortsSection = ({ nearbyResorts, isSummerMode = false }: Props) => {
  const { t } = useOTSTranslation('common');

  const slides: SwiperSlideItem[] = useMemo(() => nearbyResorts.map((resort) => ({
    key: resort.uuid,
    content: (
      <Link href={Routes.resortTripPlanningOverview({ ...resort, region: resort.region.slug })}>
        <div className="column">
          <div className={styles.row}>
            <ImageComponent
              alt={resort.imageCaption}
              src={resort.image}
              className={styles.image}
            />
          </div>
          <div className={classNames(styles.row, styles.text_container)}>
            <div className={styles.resort_name}>{resort.title}</div>
            <div>
              <button className={styles.link} type="button">
                VIEW
              </button>
            </div>
          </div>
        </div>
      </Link>
    ),
  })), [nearbyResorts]);

  return (
    <section id={styles.nearbyResorts}>
      <SectionHeader title={t('common.nearbyResorts')} isSummerMode={isSummerMode} />
      <SwiperComponent
        slides={slides}
        breakpoints={swiperBreakpoints}
        spaceBetween={16}
        navigationThreshold={3}
        swiperClassName={styles.swiper}
        slideClassName={classNames(styles.height_auto, styles.slide)}
        navButtonClassName={styles.swiperNavButton}
        prevButtonClassName={styles.swiperButtonPrev}
        nextButtonClassName={styles.swiperButtonNext}
      />
    </section>
  );
};
